<label class="input-label" [class.readonly]="readonly" [id]="id">
  @if (!readonly && props.required) {
    <span class="required-question">*</span>
  }
  <span
    [innerHTML]="
      (useAttributeDescription ? props.description : props.name) | safeHtml
    "
  ></span>
</label>
@if (!readonly) {
  <ng-content></ng-content>
}
